import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Users, Key, ArrowLeft } from 'lucide-react';
import FormularioRegistroCongreso from '../../components/FormularioRegistroCongreso';
import FormularioRecuperarPassword from '../../components/FormularioRecuperarPassword';

/**
 * Página de acceso a congresos
 * Permite registrarse o recuperar contraseña
 */
const AccesoCongresos = () => {
    const [activeTab, setActiveTab] = useState('registro'); // 'registro' | 'recuperar'

    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12">
            <div className="max-w-4xl mx-auto px-6">
                {/* Breadcrumb / Navegación */}
                <div className="mb-8">
                    <Link
                        to="/congresos"
                        className="inline-flex items-center gap-2 text-[#0b742f] hover:text-[#085a24] font-semibold transition-colors"
                    >
                        <ArrowLeft className="w-5 h-5" />
                        Volver a Congresos
                    </Link>
                </div>

                {/* Hero Header */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                        Acceso a Plataforma de Congresos
                    </h1>
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                        Regístrese para participar en nuestros congresos o recupere sus credenciales de acceso
                    </p>
                </div>

                {/* Tabs */}
                <div className="flex justify-center mb-8">
                    <div className="inline-flex bg-gray-100 rounded-lg p-1 shadow-inner">
                        <button
                            onClick={() => setActiveTab('registro')}
                            className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 ${activeTab === 'registro'
                                    ? 'bg-white text-[#0b742f] shadow-md'
                                    : 'text-gray-600 hover:text-gray-900'
                                }`}
                        >
                            <Users className="w-5 h-5" />
                            Nuevo Registro
                        </button>
                        <button
                            onClick={() => setActiveTab('recuperar')}
                            className={`px-6 py-3 rounded-lg font-semibold transition-all duration-200 flex items-center gap-2 ${activeTab === 'recuperar'
                                    ? 'bg-white text-[#e87729] shadow-md'
                                    : 'text-gray-600 hover:text-gray-900'
                                }`}
                        >
                            <Key className="w-5 h-5" />
                            Recuperar Contraseña
                        </button>
                    </div>
                </div>

                {/* Contenido de tabs */}
                <div className="max-w-3xl mx-auto">
                    {activeTab === 'registro' ? (
                        <FormularioRegistroCongreso />
                    ) : (
                        <FormularioRecuperarPassword />
                    )}
                </div>

                {/* Información adicional */}
                <div className="mt-12 max-w-3xl mx-auto">
                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 border-l-4 border-blue-500">
                        <h3 className="text-lg font-bold text-blue-900 mb-3">
                            ℹ️ Información Importante
                        </h3>
                        <ul className="space-y-2 text-gray-700">
                            <li className="flex items-start gap-2">
                                <span className="text-blue-600 font-bold mt-1">•</span>
                                <span>El registro es necesario para participar en los congresos virtuales del CENID.</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-blue-600 font-bold mt-1">•</span>
                                <span>Recibirá un correo electrónico con sus credenciales de acceso a la plataforma.</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-blue-600 font-bold mt-1">•</span>
                                <span>Si no recibe el correo, revise su carpeta de spam o correo no deseado.</span>
                            </li>
                            <li className="flex items-start gap-2">
                                <span className="text-blue-600 font-bold mt-1">•</span>
                                <span>Puede recuperar su contraseña en cualquier momento usando su correo electrónico registrado.</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Contacto */}
                <div className="mt-8 text-center">
                    <p className="text-gray-600">
                        ¿Necesita ayuda? Contáctenos en{' '}
                        <a
                            href="mailto:cenid@cenid.org"
                            className="text-[#0b742f] font-semibold hover:underline"
                        >
                            cenid@cenid.org
                        </a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AccesoCongresos;
